import {useState} from "react";

import {useDownload} from "base/file/utilities";
import {ErrorAlerts} from "base/error/components";
import Tooltip from "@mui/material/Tooltip";
import IconButton from "@mui/material/IconButton";

import DownloadOutlinedIcon from "@mui/icons-material/DownloadOutlined";

export const EntityTableDirectDownloadButton = ({service, filter}) => {
    const download = useDownload();

    const [error, setError] = useState(null);

    const handleClick = () => {
        downloadData();
    };

    const downloadData = () => {
        setError(null);
        service
            .getExport(filter)
            .then(response => {
                download(response);
            })
            .catch(error => {
                setError(error);
            });
    };

    return (
        <div>
            <Tooltip title="Descargar tabla" placement="bottom-end">
                <IconButton aria-label="download-table" onClick={handleClick}>
                    <DownloadOutlinedIcon />
                </IconButton>
            </Tooltip>

            {error && <ErrorAlerts error={error} />}
        </div>
    );
};
